import React, { useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Divider,
  Grid,
  Skeleton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getDeveloper } from "../../features/Developers/developerSlice";

const About = () => {
  const { dev } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDeveloper(`${dev}`));
  }, []);
  const { developer, developers, pending } = useSelector(
    (state) => state.developers
  );
  const { attributes, home } = developer;
  return (
    <>
      <Container
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="h3">About Me</Typography>
            <Divider />
          </Box>
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12} md={5}>
                <Typography variant="body1" sx={{ textAlign: "right" }}>
                  {home?.[0]?.about_title && !pending ? (
                    home?.[0]?.about_title
                  ) : (
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "3rem" }}
                      width="30vw"
                      height={100}
                    />
                  )}
                </Typography>
              </Grid>

              <Grid item md={7}>
                <Typography variant="body2" sx={{}}>
                  {home?.[0]?.about_description && !pending ? (
                    home?.[0]?.about_description
                  ) : (
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "5rem" }}
                      width="50vw"
                      height={300}
                    />
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default About;
